export default [
	{
	title: 'Tableau de bord',
	route: 'home',
	icon: 'HomeIcon',
	},
	{
	title: 'Statistiques',
	route: 'stat',
	icon: 'BarChart2Icon',
	},
	{
	title: 'Stats clients finaux',
	route: 'stat-clients',
	icon: 'UsersIcon',
	},
	{
	title: 'Fichiers Azure',
	route: 'fichiers-azure',
	icon: 'CloudIcon',
	},
	{
	title: 'Signatures HF',
	route: 'signatures-hf',
	icon: 'EditIcon',
	},
	{
	title: 'Documentation',
	route: 'docs',
	icon: 'FileTextIcon',
	},
]
